import React from 'react';
import bars from '../../assets/extended-welcome-flow/icons/bars.png';
import barsNavy from '../../assets/extended-welcome-flow/icons/bars-navy.png';
import signpost from '../../assets/extended-welcome-flow/icons/signpost.png';
import gear from '../../assets/extended-welcome-flow/icons/gear.png';
import check from '../../assets/extended-welcome-flow/icons/check.png';
import chat from '../../assets/extended-welcome-flow/icons/chat.png';
import calendar from '../../assets/extended-welcome-flow/icons/calendar.png';
import sparkles from '../../assets/extended-welcome-flow/icons/sparkles.png';
import cursor from '../../assets/extended-welcome-flow/icons/cursor.png';
import pie from '../../assets/extended-welcome-flow/icons/pie.png';
import trend from '../../assets/extended-welcome-flow/icons/trend.png';
import play from '../../assets/extended-welcome-flow/icons/play.png';
import clipboard from '../../assets/extended-welcome-flow/icons/clipboard.png';
import bulb from '../../assets/extended-welcome-flow/icons/bulb.png';
import nodes from '../../assets/extended-welcome-flow/icons/nodes.png';
import people from '../../assets/extended-welcome-flow/icons/people.png';
import trophy from '../../assets/extended-welcome-flow/icons/trophy.png';
import doc from '../../assets/extended-welcome-flow/icons/doc.png';
import grip from '../../assets/extended-welcome-flow/icons/grip.png';

const IMAGES = {
  chart: bars,
  chartNavy: barsNavy,
  signpost,
  gear,
  check,
  chat,
  calendar,
  sparkles,
  cursor,
  pie,
  trend,
  play,
  clipboard,
  bulb,
  nodes,
  people,
  trophy,
  doc,
  grip,
};

const stroke = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

function Arrow({ className, points }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d={points} {...stroke} />
    </svg>
  );
}

export function Icon({ name, className }) {
  if (name === 'arrowRight') {
    return <Arrow className={className} points="M5 12h14M13 6l6 6-6 6" />;
  }
  if (name === 'arrowLeft') {
    return <Arrow className={className} points="M19 12H5M11 6l-6 6 6 6" />;
  }

  const src = IMAGES[name];
  if (!src) return null;
  return <img src={src} alt="" className={className} draggable={false} />;
}
